export { default } from "./useGuidedHighlightingFeedbackGet";
